module.exports = __webpack_public_path__ + "static/03-094959627155ea7a30fc50d8259f3081.jpg";